<template>
  <div class="page-add">
    <div class="add-title">新增问卷</div>
    <QuestionForm :submitApi="api" />
  </div>
</template>

<script>
import { saveQuestionnaire } from "@/api/questionnaire";

import QuestionForm from '../component/questionForm.vue'

export default {
  name: "questionnaireAdd",
  components: { QuestionForm },
  data() {
    return {
      api: saveQuestionnaire,
    };
  },

  created() {
  },
  watch: {

  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
